import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "scenario-field-header with-elements bg-secondary text-white" }, " Scenario Fee Settings ", -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("label", { class: "pb-2" }, "Scenario Fee: $", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        max: "255",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.scenario_fee) = $event)),
        onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setProcessingFee && _ctx.setProcessingFee(...args)))
      }, null, 544), [
        [_vModelText, _ctx.scenario_fee]
      ]),
      _createElementVNode("p", null, [
        _cache[3] || (_cache[3] = _createTextVNode("Processing Fee: $")),
        _createElementVNode("span", null, _toDisplayString(_ctx.processing_fee == 0 ? 0.00 : _ctx.processing_fee.toFixed(2)), 1)
      ]),
      _createElementVNode("p", null, "Participant will be required to pay $" + _toDisplayString(_ctx.scenario_fee == 0 ? 0.00 : (_ctx.scenario_fee + _ctx.processing_fee).toFixed(2)) + " after fees.", 1),
      _createElementVNode("button", {
        class: "btn btn-primary btn-md my-3 float-end",
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveScenarioFeeSettings && _ctx.saveScenarioFeeSettings(...args)))
      }, "Save")
    ])
  ], 64))
}